import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import TagsRenderer from 'timeSheet/components/CellRenderers/TagsRenderer';

const useTagsColumn = ({ mappedTags }) => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return TagsRenderer({
        rowData: params.data,
        columnData: { mappedTags }
      });
    },
    [mappedTags]
  );

  return useMemo(
    () => ({
      field: 'tags',
      headerName: t('tags'),
      initialHide: true,
      cellClass: 'justify-start',
      width: 200,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useTagsColumn;
